/**
 * Created by amitt
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("user-management-templates/users/usersAssignSkillsDialogView.tmpl");
    var Button = require("ui/button/Button");
    var Multiselect = require("ui/multiselect/Multiselect");

    var UsersAssignSkillDialogView = {};

    LE.module("LEUserManagement", function (LEUserManagement, LE, Backbone, Marionette, $, _) {
        UsersAssignSkillDialogView = Marionette.ItemView.extend({
            className: "assign-skill-container",
            template: template,
            ui: {
                multiSelect: ".assign-skill-multiselect",
                cancelButton: ".assign-skill-cancel-btn",
                saveButton: ".assign-skill-save-btn"
            },
            uiComponents: {
                skillsMultiSelect: {
                    type: Multiselect,
                    options: {
                        container: "view.ui.multiSelect",
                        permutation: Multiselect.PERMUTATION.SMALL,
                        trim: true,
                        items: "view._getSkillsArr",
                        floating: false,
                        list: {
                            maxShownItems: 5,
                            newItem: {
                                visible: false
                            }
                        },
                        tagsContainer: {
                            placeholder: LE.translator.translate("LEUserManagement.userList.assignSkills.multiselect.placeholder"),
                            inlineErrorText: LE.translator.translate("LEUIComponents.errors.tagscontainer.viewValidation.selectFromList"),
                            inlineErrorBubbleZIndex: 10000,
                            maxShownLines: 3
                        }
                    }
                },
                saveButton: {
                    type: Button,
                    options: {
                        el: "view.ui.saveButton",
                        permutation: Button.PERMUTATION.BTN_PRIMARY
                    },
                    events: {
                        "click": "_onSaveClick"
                    }
                },
                cancelButton: {
                    type: Button,
                    options: {
                        el: "view.ui.cancelButton",
                        permutation: Button.PERMUTATION.LINK
                    },
                    events: {
                        "click": "_onCancelCLick"
                    }
                }
            },

            initialize: function (options) {
                options = options || {};
                this.selectedUsers = options.selectedUsers;
                this.skillsCollection = options.skillsCollection;
                this.originalySharedSkills = null;
                this._bindEvents();
            },

            _bindEvents: function () {
                this.listenTo(this, "dialog:closeButtonClick", this._onCloseClick);
            },

            customTemplateHelpers: function() {
                var span = "<strong>" + this.selectedUsers.length + "</strong>";
                return {
                    assignSkillsSubtitle : LE.translator.translate({key: "LEUserManagement.userList.assignSkills.subtitle", args: [{key: span, isTranslate: false}]})
                };
            },

            _getSkillsArr: function () {
                LEUserManagement.logger.debug("Generating the assignSkill multiselect array", "UsersAssignSkillDialogView:_getSkillsArr");
                var isTaggingByLobFeatureEnabled = LE.sessionManager.hasEntitiesTaggingByLobFeature();

                var sharedAssignments = this._getSharedAssignments();
                var usersLobs = sharedAssignments.lobs;
                this.originalySharedSkills = sharedAssignments.skills;

                var skillsMultiselectArr = [];
                this.skillsCollection.each(function (skillModel) {
                    var skillLobs = skillModel.getLobs();
                    var isSkillSelected = _.contains(this.originalySharedSkills, skillModel.id);
                    var isSkillAllowed = !isTaggingByLobFeatureEnabled || LE.crossModule("dataModule", LE.media.actions.request, LE.mediaCodes.dataModule.reqres.isSkillAllowedForSelection, skillLobs, usersLobs);
                    if (isSkillAllowed || isSkillSelected) {
                        skillsMultiselectArr.push({
                            id: skillModel.id,
                            value: skillModel.getName(),
                            selected: isSkillSelected
                        });
                    }
                }, this);

                return skillsMultiselectArr;
            },

            _getSharedAssignments: function() {
                var allUsedSkills = []; //array of arrays. each array includes the the skill ids of the selected users
                var allUsedLobs = []; // array of arrays. each array includes the lob ids of the selected users.

                this.selectedUsers.forEach(function(user) {
                    allUsedSkills.push(user.getSkills());

                    var userLobs = user.getLobs();
                    if (!_.isEmpty(userLobs)) {
                        allUsedLobs.push(user.getLobs());
                    }
                });


                var usersSkills = _.intersection.apply(null, allUsedSkills);
                var usersLobs = [];

                var allUsedLobsUnion = _.union.apply(null, allUsedLobs);
                if (allUsedLobsUnion.length > 0) {
                    var lobsIntersection = _.intersection.apply(null, allUsedLobs);
                    if(lobsIntersection.length > 0) {
                        usersLobs = lobsIntersection;
                    }
                    else {
                        usersLobs = [undefined]; // there is usage of lobs, but the intersection is empty. so add "undefined" to the lobs because empty array is considered as "all lobs"
                    }
                }

                return {
                    skills: usersSkills,
                    lobs: usersLobs
                };
            },

            _onSaveClick: function () {
                var skillsToAdd = _.difference(this.uiComponents.skillsMultiSelect.getSelectedItems(), this.originalySharedSkills);
                var skillsToDeduct = _.difference(this.originalySharedSkills, this.uiComponents.skillsMultiSelect.getSelectedItems());

                if (skillsToDeduct.length === 0 && skillsToAdd.length === 0) {
                    LEUserManagement.logger.debug("No need to save the data - no changes were made", "UsersAssignSkillDialogView:_onSaveClick");
                    this._closeDialog();
                }
                else {
                    LEUserManagement.logger.debug("changes were made to assigned skills", "UsersAssignSkillDialogView:_onSaveClick");
                    this.trigger("dialogInnerView:onSaveClick", {
                        selectedUsers: this.selectedUsers,
                        skillsToAdd: skillsToAdd,
                        skillsToDeduct: skillsToDeduct
                    });
                }
            },

            _onCancelCLick: function () {
                LEUserManagement.logger.debug("dialog innerView cancel button clicked", "UsersAssignSkillDialogView:_onCancelCLick");
                this._closeDialog();
            },

            _onCloseClick: function () {
                LEUserManagement.logger.debug("dialog close button clicked", "UsersAssignSkillDialogView:_onCloseClick");
                this._closeDialog();
            },

            _closeDialog: function () {
                this.trigger("dialogInnerView:closeDialog");
            }
        });
    });

    return UsersAssignSkillDialogView;
});
